document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-kosas-carousel-action]');
  if (!control) return;

  const section = control.closest('.kosas-section');
  const carousel = section?.querySelector('[data-kosas-carousel]');
  if (!carousel) return;

  const direction = control.dataset.kosasCarouselAction === 'previous' ? -1 : 1;
  carousel.scrollBy({ left: carousel.clientWidth * 0.84 * direction, behavior: 'smooth' });
});
